/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForRedhatSatellite extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForRedhatSatellite");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForRedhatSatellite.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForRedhatSatellite>): ServiceAccountNativeDetailsForRedhatSatellite {
        let obj = Object.assign(new ServiceAccountNativeDetailsForRedhatSatellite(), model);
        ServiceAccountNativeDetailsForRedhatSatellite.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForRedhatSatellite>): ServiceAccountNativeDetailsForRedhatSatellite {
        if (!model) return null;
        return ServiceAccountNativeDetailsForRedhatSatellite.newInstance(<ServiceAccountNativeDetailsForRedhatSatellite> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForRedhatSatellite) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForRedhatSatellite.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForRedhatSatellite): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForRedhatSatellite.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
